function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_427_28405)",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.998 17.002H11M17.502 15.564l-1.876 1.876-1.125-1.126"
}), /*#__PURE__*/React.createElement("rect", {
  x: "2.997",
  y: "2.996",
  width: "18.008",
  height: "18.008",
  rx: "3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.001 13.5H6.998"
}), /*#__PURE__*/React.createElement("rect", {
  x: "6.998",
  y: "6.998",
  width: "10.004",
  height: "3.001",
  rx: ".5"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_427_28405"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));